import axios from "axios"
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Button, ErrorMsg } from "@onegovbugs/onegov-react-components";
import styles from "./Location.module.scss";
import {
  isSelected,
  validate,
  objExistInArray,
  scrollToError,
  isCompleted,
} from "../../../utils/Validation";
import { useSelector, useDispatch } from "react-redux";
import {
  getTenureTypes,
  getLgas,
  getKarstAreas,
  getMarineParks,
  getLls,
  getStateForests,
} from "../../../redux/actions";
import { searchLocations } from "redux/actions/floraFauna/locationData";
import AsyncSelect from "react-select/async";
import { storeLocationData } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import { withRouter } from "react-router-dom";
import ScrollToTop from "../../../utils/ScrollToTop";

const LocationForm = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  let index = props.match.params.id;

  const locationDetail = useSelector((state) => state.locationDetail);
  const oidc = useSelector((state) => state.oidc);
  const token = oidc.user && oidc.user.access_token;

  const [locationList, setlocationList] = useState(
    locationDetail && locationDetail.locationList
      ? locationDetail.locationList.map((on) => ({ ...on }))
      : []
  );
  const editLocation =
    index && locationList && locationList.length > 0
      ? locationList[index]
      : undefined;

  const [tenureType, setTenureType] = useState(
    editLocation ? editLocation.tenureType : null
  );
  const [karstArea, setKastArea] = useState(
    editLocation ? editLocation.karstArea : null
  );
  const [marinePark, setMarinePark] = useState(
    editLocation ? editLocation.marinePark : null
  );
  const [locationSearch, setLocationSearch] = useState(
    editLocation ? editLocation.locationSearch : null
  );
  const [lga, setLGA] = useState(editLocation ? editLocation.lga : null);
  const [stateForest, setStateForest] = useState(
    editLocation ? editLocation.stateForest : null
  );
  const [other, setOther] = useState(editLocation ? editLocation.other : "");
  const [lls, setLLS] = useState(editLocation ? editLocation.lls : null);
  // Get location RefData
  useEffect(() => {
    dispatch(getTenureTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getLgas());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getLls());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getKarstAreas());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getMarineParks());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getStateForests());
  }, [dispatch]);

  // toggle dropdowns
  const [showLGA, setLGAView] = useState(false);
  const [showMarinePark, setMarineParkView] = useState(false);
  const [showForest, setStateForestView] = useState(false);
  const [showKarst, setKarstView] = useState(false);
  const [showLocationSearch, setLocationSearchView] = useState(false);
  const [showLLS, setLLSView] = useState(false);
  const [showOther, setOtherView] = useState(false);

  useEffect(() => {
    const tenureValue = tenureType ? tenureType.value : null;
    switch (tenureValue) {
      case "LGA":
        setOtherView(true);
        setLGAView(true);
        setMarineParkView(false);
        setMarinePark(null);
        setLLSView(false);
        setLLS(null);
        setStateForestView(false);
        setStateForest(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        setKarstView(false);
        setKastArea(null);
        break;
      case "Marine Park":
        setOtherView(true);
        setMarineParkView(true);
        setLGAView(false);
        setLGA(null);
        setLLSView(false);
        setLLS(null);
        setStateForestView(false);
        setStateForest(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        setKarstView(false);
        setKastArea(null);
        break;
      case "LLS Region":
        setOtherView(true);
        setLLSView(true);
        setLGAView(false);
        setLGA(null);
        setMarineParkView(false);
        setMarinePark(null);
        setStateForestView(false);
        setStateForest(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        setKarstView(false);
        setKastArea(null);
        break;
      case "State Forests":
        setOtherView(true);
        setStateForestView(true);
        setLGAView(false);
        setLGA(null);
        setLLSView(false);
        setLLS(null);
        setMarineParkView(false);
        setMarinePark(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        setKarstView(false);
        setKastArea(null);
        break;
      case "NPWS Estate":
        setOtherView(true);
        setLocationSearchView(true);
        setLGAView(false);
        setLGA(null);
        setMarineParkView(false);
        setMarinePark(null);
        setLLSView(false);
        setLLS(null);
        setStateForestView(false);
        setStateForest(null);
        setKarstView(false);
        setKastArea(null);
        break;
      case "Karst Area":
        setKarstView(true);
        setLGAView(false);
        setLGA(null);
        setMarineParkView(false);
        setMarinePark(null);
        setLLSView(false);
        setLLS(null);
        setStateForestView(false);
        setStateForest(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        break;
      case "Other":
        setOtherView(true);
        setOtherView(true);
        setKarstView(false);
        setKastArea(null);
        setLGAView(false);
        setLGA(null);
        setMarineParkView(false);
        setMarinePark(null);
        setLLSView(false);
        setLLS(null);
        setStateForestView(false);
        setStateForest(null);
        setLocationSearchView(false);
        setLocationSearch(null);
        break;
    }
  });

  // Dropdown options
  const tenureTypeOptions =
    locationDetail && locationDetail.tenureTypes
      ? locationDetail.tenureTypes
      : [];

  const karstAreaOptions =
    locationDetail && locationDetail.karstAreas
      ? locationDetail.karstAreas
      : [];
  const marineParkOptions =
    locationDetail && locationDetail.marineParks
      ? locationDetail.marineParks
      : [];
  const lgaOptions =
    locationDetail && locationDetail.lgas ? locationDetail.lgas : [];
  const llsOptions =
    locationDetail && locationDetail.lls ? locationDetail.lls : [];
  const stateForestsOptions =
    locationDetail && locationDetail.stateForests
      ? locationDetail.stateForests
      : [];

  const searchLocationsOptions = (keyWord) => {
    if (keyWord.length > 2) {
      return axios
        .get(`${process.env.REACT_APP_BASE_URL}/nativespeciesapi/V1/florafauna/searchLocation?keyword=${keyWord}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        })
        .then(r => r.data.map(d => ({
            value: d.value,
            label: d.label
          })
        ));
    } else {
      return new Promise(resolve => resolve([]))
    }
  };

  //validaitons
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    tenureType: false,
    locationAlreadyExists: false,
    isLgaRequired: false,
    isLlsRequired: false,
    isMarineParkRequired: false,
    isStateForestRequired: false,
    isKarstAreaRequired: false,
    isLocSearchRequired: false,
    isOtherRequired: false
  });

  const validators = [
    {
      fieldName: "tenureType",
      fieldValue: tenureType,
      isValid: isSelected,
    },
    {
      fieldName: "isLgaRequired",
      fieldValue: lga,
      isValid : (v) => !showLGA || isSelected(v),
    },
    {
      fieldName: "isLlsRequired",
      fieldValue: lls,
      isValid: (v) => !showLLS || isSelected(v),
    },
    {
      fieldName: "isMarineParkRequired",
      fieldValue: marinePark,
      isValid : (v) => !showMarinePark || isSelected(v),
    },
    {
      fieldName: "isStateForestRequired",
      fieldValue: stateForest,
      isValid: (v) => !showForest ||  isSelected(v),
    },
    {
      fieldName: "isKarstAreaRequired",
      fieldValue: karstArea,
      isValid: (v) => !showKarst || isSelected(v),
    },
    {
      fieldName: "isOtherRequired",
      fieldValue: other,
      isValid : (v) => isCompleted(v) || ( tenureType && tenureType.value !== "Other"),
    },
    {
      fieldName: "locationAlreadyExists",
      fieldValue: locationList,
      isValid: (v) => {
        if ((v && v.length === 0) || index !== undefined) return true;
        const newLocation = {
          tenureType: tenureType ? tenureType : "",
          lls: lls ? lls : "",
          lga: lga ? lga : "",
          marinePark: marinePark ? marinePark : "",
          karstArea: karstArea ? karstArea : "",
          stateForest: stateForest ? stateForest : "",
          locationSearch: locationSearch ? locationSearch : "",
          other: other ? other : "",
        };
        return objExistInArray(v, newLocation);
      },
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [tenureType, lga, lls, karstArea, marinePark, stateForest, other]);

  const storeData = () => {
    const locationRecord = {
      locationList: [
        ...locationList,
        {
          tenureType: tenureType ? tenureType : "",
          lls: lls ? lls : "",
          lga: lga ? lga : "",
          marinePark: marinePark ? marinePark : "",
          karstArea: karstArea ? karstArea : "",
          stateForest: stateForest ? stateForest : "",
          locationSearch: locationSearch ? locationSearch : "",
          other: other ? other : "",
        },
      ],
    };
    dispatch(storeLocationData(locationRecord));
  };

  const editData = (updateLocation) => {
    const locationRecord = {
      locationList: updateLocation,
    };

    dispatch(storeLocationData(locationRecord));
  };

  const saveLocationData = () => {
    debugger;
    if (locationList && locationList.length > 0) {
      if (index) {
        let updateLocation = [...locationList];

        updateLocation[index] = {
          tenureType: tenureType ? tenureType : "",
          lls: lls ? lls : "",
          lga: lga ? lga : "",
          marinePark: marinePark ? marinePark : "",
          karstArea: karstArea ? karstArea : "",
          stateForest: stateForest ? stateForest : "",
          locationSearch: locationSearch ? locationSearch : "",
          other: other ? other : "",
        };
        editData(updateLocation);
      } else {
        storeData();
      }
    } else {
      storeData();
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="tenureType">Tenure Type</label>
          <Select
            id={"inputTenureType"}
            value={tenureType}
            onChange={setTenureType}
            className={styles.select}
            options={tenureTypeOptions}
          />
          {errors.tenureType && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Tenure Type is required."}
            />
          ) : null}
        </div>
      </div>
      {showForest && (
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="stateForest">State Forest</label>
            <Select
              id="inputStateForest"
              value={stateForest}
              className={styles.select}
              onChange={setStateForest}
              className={styles.select}
              options={stateForestsOptions}
            />
            {errors.isStateForestRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"State Forest is required."}
            />
          ) : null}
          </div>
        </div>
      )}
      {showKarst && (
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="karstArea">Karst Area</label>
            <Select
              id="inputKastArea"
              value={karstArea}
              onChange={setKastArea}
              className={styles.select}
              options={karstAreaOptions}
            />
            {errors.isKarstAreaRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Karst Area is required."}
            />
          ) : null}
          </div>
        </div>
      )}
      {showMarinePark && (
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="marinePark">Marine Park</label>
            <Select
              id="inputMarinePark"
              className={styles.select}
              options={marineParkOptions}
              value={marinePark}
              onChange={setMarinePark}
            />
            {errors.isMarineParkRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Marine Park is required."}
            />
          ) : null}
          </div>
        </div>
      )}
      {showLGA && (
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="dob">LGA</label>
            <Select
              id="inputLGA"
              className={styles.select}
              options={lgaOptions}
              value={lga}
              onChange={setLGA}
            />
            {errors.isLgaRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"LGA is required."}
            />
          ) : null}
          </div>
        </div>
      )}
      {showLLS && (
        <div className={"row"}>
          <div className={`col-12 col-sm-6`}>
            <label htmlFor="lls">LLS</label>
            <Select
              id="inputLLS"
              className={styles.select}
              options={llsOptions}
              value={lls}
              onChange={setLLS}
            />
            {errors.isLlsRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"LLS is required."}
            />
          ) : null}
          </div>
        </div>
      )}      
      {showLocationSearch && (
        <div className={styles.asyncSelect}>
          <div className={"row"}>
            <div className={"col-12 col-sm-6"}>
            <label htmlFor="speciesCode">Branch / Region / Area / Park</label>
            <AsyncSelect
              id="inputRegion"
              cacheOptions
              value={locationSearch}
              placeholder={"Type to search"}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              isClearable              
              loadOptions={searchLocationsOptions}
              // loadOptions={(keyWord, callback) => {
              //   if (keyWord.length > 2) {
              //     searchLocationsOptions(keyWord, callback);
              //   } else {
              //     callback([]);
              //   }
              // }}
              className={styles.AsyncSelect}
              onChange={setLocationSearch}
            />
          </div>
        </div>
        </div>
      )}
      {showOther && (
        <div className={"row"}>
          <div className={"col-12 col-sm-6"}>
            <label htmlFor="other">{errors.isOtherRequired ? 'Other' : 'Other (Optional)'}</label>
            <textarea
              id="inputOther"
              value={other}
              onChange={(event) => {
                setOther(event.target.value);
              }}
            />
            {errors.isOtherRequired && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Other is required."}
            />
          ) : null}
          </div>
        </div>
      )}
      {errors.locationAlreadyExists && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Location detail already exists."}
        />
      ) : null}
      <div className={"row " + styles.buttonCont}>
        <div className={"col-12"}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                saveLocationData();
                props.history.push(`/flora-fauna/location`);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Save
          </Button>
          <Button
            secondary
            onClick={() => {
              setShowErrors(false);
              props.history.push(`/flora-fauna/location`);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <LocationForm {...props} />);
